import { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import zIndex from 'theme/zIndex'
import { useLottie } from 'lottie-react'

const SIZES = {
  sm: 90,
  md: 140,
}

const StyledLoader = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: ${props => props.position};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: ${props => SIZES[props.size]}px;
  height: ${props => SIZES[props.size]}px;
  z-index: ${props => props.theme.zIndex[props.zIndex]};
  transition: ${props =>
    props.theme.internalMixins.setTransition(['opacity', 'visibility'])};

  ${props =>
    props.position === 'fixed'
      ? `
    z-index: ${props.theme.zIndex.max};
  `
      : ''}

  ${props =>
    props.hide
      ? `
    opacity: 0;
    visibility: hidden;
  `
      : ''}

  svg {
    width: ${props => SIZES[props.size]}px !important;
    height: ${props => SIZES[props.size]}px !important;
  }
`

const Loader = props => {
  const { View } = useLottie({
    path:
      props.variant === 'primary'
        ? '//cdn1.godonde.com/app-assets/animations/loader-primary.json'
        : '//cdn1.godonde.com/app-assets/animations/loader.json',
    loop: true,
    autoplay: true,
  })

  return <StyledLoader {...props}>{View}</StyledLoader>
}

Loader.propTypes = {
  position: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  zIndex: PropTypes.oneOf(Object.keys(zIndex)),
  hide: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'default']),
}

Loader.defaultProps = {
  position: 'static',
  size: 'md',
  zIndex: 'primary',
  variant: 'default',
}

export default Loader
